<template>
  <div class="container-fluid">
    <properties-payment-form
      :loading="loading"
      :propertiesPaymentData="propertiesPayment"
      :formErrors="formErrors"
      @propertiesPaymentSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPropertiesPayment from "../defaultPropertiesPayment";
import PropertiesPaymentForm from "../partials/PropertiesPaymentForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PropertiesPaymentForm,
  },

  mixins: [alertLeave],

  data() {
    const propertiesPayment = cloneDeep(defaultPropertiesPayment);
    const me = this.$store.getters["profile/me"];
    return {
      propertiesPayment: propertiesPayment,
      formErrors: null,
      loading: false,
      dataReceipt: {
        email: "",
        attention: "",
        amount: null,
        excerpt: "",
        date: null,
        ids: []
      }
    };
  },

  created() {},

  methods: {
    async handleSubmit(propertiesPayment, refundPropertyPayment = null) {
      this.loading = true;
      const propertiesPaymentData = cloneDeep(propertiesPayment);
      const propertiesPaymentPropertiesData = cloneDeep(
        propertiesPayment.propertiesPaymentsProperties
      );

      delete propertiesPaymentData.propertiesPaymentsProperties;

      try {
        await this.$store.dispatch(
          "propertiesPayments/add",
          propertiesPaymentData
        );
        const propertiesPayment =
          this.$store.getters["propertiesPayments/propertiesPayment"];
        this.dataReceipt.attention = propertiesPayment.attention;
        this.dataReceipt.email = propertiesPayment.email;
        this.dataReceipt.amount = propertiesPayment.amount;
        this.dataReceipt.date = propertiesPayment.date;
        this.dataReceipt.excerpt = propertiesPayment.excerpt;
        this.dataReceipt.ids.push(propertiesPayment.id);

        for (const [index, propertiesPaymentProperty] of propertiesPaymentPropertiesData.entries()) {
          const isLast = index === propertiesPaymentPropertiesData.length - 1;
          if (refundPropertyPayment && isLast) {
            propertiesPaymentProperty.amount = parseFloat(propertiesPaymentProperty.amount) + parseFloat(Math.abs(refundPropertyPayment.amount)); 
          }
          const propertiesPaymentPropertyData = {
            ...propertiesPaymentProperty,
            propertiesPayment: propertiesPayment,
            relationshipNames: ["property", "propertiesPayment"],
          };
          await this.$store.dispatch(
            "propertiesPaymentsProperties/add",
            propertiesPaymentPropertyData
          );
        }
        // remboursement
        if(refundPropertyPayment){
          const refundPropertyPaymentData = cloneDeep(refundPropertyPayment);
          const property = {
            id : refundPropertyPaymentData.propertiesPaymentsProperties.property.id,
            type : "properties"
          };
          delete refundPropertyPaymentData.propertiesPaymentsProperties;

          await this.$store.dispatch(
            "propertiesPayments/add",
            refundPropertyPaymentData
          );
          const refundPayment =
            this.$store.getters["propertiesPayments/propertiesPayment"];

          this.dataReceipt.ids.push(refundPayment.id);

          await this.$store.dispatch("propertiesPaymentsProperties/add", {
            type: "properties-payments-properties",
            amount: refundPropertyPaymentData.amount,
            property: property,
            propertiesPayment: refundPayment,
            relationshipNames: ["property", "propertiesPayment"],
          });
        }

        if(this.dataReceipt.email != null && this.dataReceipt.email != ""){
          await this.$store.dispatch(
            "propertiesPayments/sendMailReceipt", this.dataReceipt
          );
        }

        this.$notify({
          type: "success",
          message: this.$t("PROPERTIES_PAYMENTS.PROPERTIES_PAYMENT_ADDED"),
        });
        this.$emit("onViewPropertiesPayment", propertiesPayment, true);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
